<template>
  <div id="app">
    <view-port-debug></view-port-debug>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ViewPortDebug from './components/commons/ViewPortDebug';
import { getFirstBrowserLanguage } from './utils';
import { DEFAULT_LANG } from './const/lang';
import { LANGUAGE } from './const';
import { remoteSync } from './mixins';


export default {
  name: 'App',
  components: { ViewPortDebug },
  mixins: [remoteSync],
  mounted() {
    this.setLang(
      { ctx: this, value: getFirstBrowserLanguage(LANGUAGE, DEFAULT_LANG.symbol).slice(0, 2) },
    );
  },
  methods: {
    ...mapActions(['setLang']),
  },
};
</script>

<style lang="scss" src="./styles/app.scss"></style>



// WEBPACK FOOTER //
// src/App.vue